import { createUseStyles } from 'react-jss'
import { chunk } from 'lodash'
import { Button, Row, MediaQuery, Slider, Col } from 'UI'
import { CardTypes } from 'components/common/HorizontalCardRenderer'
import Text from './text.json'
import style from './style'
import CardRenderer from 'components/common/CardRenderer'
import { CourseNeutralPath } from 'navigation/Routes'

const useStyles = createUseStyles(style)

const completedCoursePercentage = 100
const numberOfCardSkeletonToShow = 4

const DesktopList = ({ courses, loading, goToCourse, goToCertificate }) => {
  const { cardsContainer } = useStyles()
  const coursesToShow = loading ? [...Array(numberOfCardSkeletonToShow).fill({ loading: true })] : courses
  return (
    <div className={cardsContainer}>
      {coursesToShow?.map((course, index) => {
        const cardUrl = CourseNeutralPath + '/' + course.Slug

        return (
          loading
            ? <CardRenderer
                loading
                cardType={CardTypes.continueCourse}
              />
            : <CardRenderer
                key={course.Id ?? index}
                loading={course.loading}
                titleAs='h3'
                course={course}
                actionButtonHeight={30}
                path={cardUrl}
                handleCardClick={() => goToCourse(course.Slug)}
                cardType={
                  !course.CompletionPercentage
                    ? CardTypes.startCourse
                    : course.CompletionPercentage < completedCoursePercentage
                      ? CardTypes.continueCourse
                      : CardTypes.historyCompletedCourses
                }
              />
        )
      })}
    </div>
  )
}

const viewCards = ({ view, courseToShow, goToLink }) =>
  courseToShow.map((item, key) =>
    (
      <div key={key} className={view}>
        {
            item.map(course => (
              course
                ? <CardRenderer
                    key={course.Id}
                    loading={course.loading}
                    path={`${CourseNeutralPath}/${course.Slug}`}
                    course={course}
                    handleCardClick={() => goToLink(course.Slug)}
                    width='calc(25% - 33px)'
                    tabletWidth={233}
                    mobileWidth={233}
                    height={245}
                  />
                : null
            ))
          }
      </div>
    )
  )

const ResponsiveList = ({ courses, loading, goToCourse }) => {
  const splicedCourses = chunk(courses, 4).map(chunkCourses => {
    chunkCourses.push(...Array(4 - chunkCourses.length))
    return chunkCourses
  })
  const courseToShow = loading ? [[...Array(4).fill({ loading: true })]] : splicedCourses
  const { root, view } = useStyles()
  return (
    <div className={root}>
      <Slider
        title={Text.coursesPlan}
        views={viewCards({ view, courseToShow, goToLink: goToCourse })}
        secondaryController
        gap={43}
        gapTablet={16}
        gapMobile={16}
      />
    </div>
  )
}

export default ({
  courses,
  count,
  learningPathId,
  fetchLearningPathCourses,
  goToCourse,
  goToCertificate,
  loading,
  parentIsLoading,
  progressionLoading,
  take,
  skip
}) => {
  const { seeMoreRow } = useStyles()
  const courseLoading = parentIsLoading || loading || progressionLoading
  const handledCourses = courses?.map(course => ({ ...course, DiscountPrice: course.PricePromo }))
  return (
    <>
      <MediaQuery ShowOnDesktop>
        <Row direction='column' gap={16} repeatCols={8} mrepeatCols={12} srepeatCols={12}>
          <Col grid={8} mgrid={12} sgrid={12}>
            <DesktopList courses={handledCourses} loading={courseLoading} goToCourse={goToCourse} goToCertificate={goToCertificate} />
            {
            count > handledCourses.length && !courseLoading
              ? (
                <Row justify='center' className={seeMoreRow} repeatCols={8}>
                  <Col grid={8} mgrid={12} sgrid={12}>
                    <Button
                      variation='text'
                      size='big'
                      label={Text.seeMore}
                      onHandleClick={() => fetchLearningPathCourses(learningPathId, take, skip)}
                    />
                  </Col>
                </Row>)
              : null
            }
          </Col>
        </Row>
      </MediaQuery>
      <MediaQuery HideOnDesktop>
        <ResponsiveList courses={handledCourses} loading={courseLoading} goToCourse={goToCourse} goToCertificate={goToCertificate} />
      </MediaQuery>
    </>
  )
}
